import React, { useState } from "react";
import { NavLink } from "react-router-dom";

import FeatureRenderer from "components/Feature/RendererContainer";

const MenuHome = () => {
  const [activeEntry, setActiveEntry] = useState(null);

  // const getCollapseIcon = entry => {
  //   const src =
  //     entry === activeEntry
  //       ? "/assets/images/icon-minus.svg"
  //       : "/assets/images/icon-add.svg";
  //   const alt = entry === activeEntry ? "Minus Icon" : "Plus Icon";
  //   return (
  //     <img className="menu__icon menu__icon--collapse" src={src} alt={alt} />
  //   );
  // };

  return (
    <ul>
      <li className="menu__item" onClick={() => setActiveEntry("Fee Reports")}>
        <NavLink to="/" exact className="menu__link" activeClassName="active" id="navBar_fee_reports">
          <img
            className="menu__icon"
            src="/assets/images/home.svg"
            alt="Document Icon"
          />
          Fee Reports
        </NavLink>
      </li>

      <FeatureRenderer feature="FeesPreferences">
        <li
          className="menu__item"
          onClick={() => setActiveEntry("Preferences")}
        >
          <NavLink
            to="/preferences"
            exact
            className="menu__link"
            activeClassName="active"
            id="navBar_preferences"
          >
            <img
              className="menu__icon"
              src="/assets/images/icon-settings.png"
              alt="Settings Icon"
            />
            Preferences
          </NavLink>
        </li>
      </FeatureRenderer>

      <FeatureRenderer feature="Analytics">
        <li
          className="menu__item"
          onClick={() => setActiveEntry("Basic Usage Report")}
        >
          <NavLink
            to="/analytics/basicusage"
            exact
            className="menu__link"
            activeClassName="active"
            id="navBar_basic_usage_report"
          >
            <img
              className="menu__icon"
              src="/assets/images/icon_report.png"
              alt="Basic Usage Icon"
            />
            Basic Usage Report
          </NavLink>
        </li>
      </FeatureRenderer>

      {/* <FeatureRenderer feature="Analytics">
        <li
          className={classNames("menu__item", {
            open: activeEntry === "Analytics"
          })}
          onClick={() =>
            setActiveEntry(x => (x === "Analytics" ? null : "Analytics"))
          }
        >
          <a href="#" className="menu__link">
            <img
              className="menu__icon"
              src="/assets/images/icon-graph.svg"
              alt="Graph Icon"
            />
            Analytics
            {getCollapseIcon("Analytics")}
          </a>

          <div className="menu__subitems">
            <NavLink
              to="/analytics/basicusage"
              exact
              className="menu__link menu__subitem"
              activeClassName="active"
            >
              Basic Usage Report
            </NavLink>
            <NavLink
              to="/analytics/reporting"
              exact
              className="menu__link menu__subitem"
              activeClassName="active"
            >
              Reporting
            </NavLink>
            <NavLink
              to="/analytics/dashboard"
              exact
              className="menu__link menu__subitem"
              activeClassName="active"
            >
              Dashboard
            </NavLink>
          </div>
        </li>
      </FeatureRenderer> */}
    </ul>
  );
};

export default MenuHome;
